if (!customElements.get('floyd-size-guide')) {
  customElements.define('floyd-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.activate(tab.dataset.chart);
        const unit = event.target.closest('[data-guide-unit]');
        if (unit && this.contains(unit)) this.setUnit(unit.dataset.guideUnit);
      }, options);
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.activate(this.tabs[next].dataset.chart);
        this.tabs[next].focus();
      }, options);
      this.followStyle(this.dataset.initialStyle, this.dataset.initialSize);
      document.addEventListener('variant:resolved', event => {
        const {sectionId, variant} = event.detail || {};
        if (sectionId !== this.dataset.section || !variant) return;
        const style = variant.options[Number(this.dataset.styleIndex)];
        const size = variant.options[Number(this.dataset.sizeIndex)];
        this.followStyle(style, size);
      }, options);
    }
    disconnectedCallback() {this.controller?.abort();this.controller = null;}
    followStyle(style, size) {
      const normalized = String(style || '').toLowerCase().replace(/[^a-z]/g, '');
      let chart;
      if (normalized.includes('zip') && normalized.includes('hood')) chart = 'zip-hoodie';
      else if (normalized.includes('hood')) chart = 'hoodie';
      else if (normalized.includes('polo')) chart = 'polo';
      else if (normalized.includes('sweater') || normalized.includes('sweatshirt')) chart = 'sweater';
      else if (normalized.includes('tshirt') || normalized.includes('tee')) chart = 'tee';
      if (style !== this.lastStyle && chart) this.activate(chart);
      this.lastStyle = style;
      this.querySelectorAll('tr[data-size]').forEach(row => row.classList.toggle('is-current', row.dataset.size === size));
    }
    activate(chart) {
      this.tabs.forEach(tab => {
        const selected = tab.dataset.chart === chart;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[role="tabpanel"]').forEach(panel => {panel.hidden = panel.dataset.chart !== chart;});
    }
    setUnit(unit) {
      if (!['in', 'cm'].includes(unit)) return;
      this.dataset.unit = unit;
      this.querySelectorAll('[data-guide-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideUnit === unit)));
    }
  });
}
